import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import DefaultSelectMenu from 'components/selectMenu/DefaultSelectMenu';
import Individual from 'components/terms/Individual';

const IndividualTerms = () => {
  const dummyData = [
    { value: '개인정보처리방침 2024.02.21(최신)', label: '개인정보처리방침 2024.02.21(최신)' }
  ];

  const navigate = useNavigate();

  const handleClickMovePage = () => {
    navigate('/terms/service');
  };

  const handleChoiceSelectBox = () => {
    console.log('.');
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Wrapper>
      <SelectMenuWrapper>
        <DefaultSelectMenu
          width="280"
          defaultValue={dummyData[0].label}
          options={dummyData}
          onChange={handleChoiceSelectBox}
        />
      </SelectMenuWrapper>
      <ContentsWrapper>
        <TabsWrapper>
          <div onClick={handleClickMovePage}>서비스이용약관</div>
          <div>개인정보처리방침</div>
        </TabsWrapper>
        <TermsContents>
          <Individual />
        </TermsContents>
      </ContentsWrapper>
    </Wrapper>
  );
};

export default IndividualTerms;

const Wrapper = styled.div`
  width: 890px;
  gap: 8px;
  margin: 0 auto;
  padding-top: 72px;
  color: ${color.gray600};
  line-height: normal;

  & .ant-table-tbody tr:first-of-type td {
    text-align: center;
    background: ${color.gray50};
    font-size: 12px;
  }

  & .ant-table-wrapper td.ant-table-cell {
    font-size: 13px;
    padding: 8px;
    white-space: pre-line;
    line-height: 17px;
  }

  & .ant-table-wrapper.addColor {
    tr.ant-table-row:nth-child(odd) {
      background: ${color.gray200};
    }
  }
`;

const ContentsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 65px;

  h3 {
    font-size: 16px;
    font-weight: 500;
  }

  p {
    font-size: 14px;
  }
`;

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 240px;
  text-align: right;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;

  & div:first-of-type {
    color: ${color.gray400};
  }

  position: sticky;
  top: 112px;
  height: max-content;
`;

const TermsContents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 585px;
`;

const SelectMenuWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin: 0 auto 24px;

  .ant-select {
    min-width: 280px;

    .ant-select-selection-item {
      font-size: 13px;
    }
  }
`;
